import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";

const DebtStatus = ({ page, setPage, formData, setFormData }) => {
    const [debtProgramError, setDebtProgramError] = useState(null);
    const [bankruptcyError, setBankruptcyError] = useState(null);
    const [consumerProposalError, setConsumerProposalError] = useState(null);

    const onDebtProgramChange = (e) => {
        setFormData({ ...formData, inDebtProgram: e.target.value });
        setDebtProgramError(null);
    }
    const onBankruptcyChange = (e) => {
        setFormData({ ...formData, inBankruptcy: e.target.value });
        setBankruptcyError(null);
    }
    const onConsumerProposalChange = (e) => {
        setFormData({ ...formData, inConsumerProposal: e.target.value });
        setConsumerProposalError(null);
    }

    useEffect(() => {
        setDebtProgramError(null);
        setBankruptcyError(null);
        setConsumerProposalError(null);
    }, [formData.lang]);

    const validateData = () => {
        var valid = true;
        if (formData.inDebtProgram === "") {
            setDebtProgramError(formData.lang === "fr" ? "La sélection d’une option est requise" : "Selecting an option is required");
            valid = false;
        } else {
            setDebtProgramError(null);
        }

        if (formData.inBankruptcy === "") {
            setBankruptcyError(formData.lang === "fr" ? "La sélection d’une option est requise" : "Selecting an option is required");
            valid = false;
        } else {
            setBankruptcyError(null);
        }

        if (formData.inConsumerProposal === "") {
            setConsumerProposalError(formData.lang === "fr" ? "La sélection d’une option est requise" : "Selecting an option is required");
            valid = false;
        } else {
            setConsumerProposalError(null);
        }

        if (valid) {
            window.dataLayer.push({'event': 'loan_step11', 'loanEvent': 'step11', 'loanEventID': 12});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step11q', 'loanEvent': 'step11q', 'loanEventID': '12q'});
            setPage(page + 1);
        }
    }

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Êtes-vous actuellement dans un programme de dette?" : "Are you currently in a debt program?"}</div>
                <ToggleButtonGroup
                    value={formData.inDebtProgram}
                    exclusive
                    onChange={onDebtProgramChange}>
                    <ToggleButton value="yes">
                        {formData.lang === "fr" ? "Oui" : "Yes"}
                    </ToggleButton>
                    <ToggleButton value="no">
                        {formData.lang === "fr" ? "Non" : "No"}
                    </ToggleButton>
                    <ToggleButton value="discharged">
                        {formData.lang === "fr" ? "Déchargé" : "Discharged"}
                    </ToggleButton>
                </ToggleButtonGroup>
                <div className="error-text">{debtProgramError}</div>
                <div className="textfield-label">{formData.lang === "fr" ? "Êtes-vous actuellement en faillite?" : "Are you currently in bankruptcy?"}</div>
                
                <ToggleButtonGroup
                    value={formData.inBankruptcy}
                    exclusive
                    onChange={onBankruptcyChange}>
                    <ToggleButton value="yes">
                        {formData.lang === "fr" ? "Oui" : "Yes"}
                    </ToggleButton>
                    <ToggleButton value="no">
                        {formData.lang === "fr" ? "Non" : "No"}
                    </ToggleButton>
                    <ToggleButton value="discharged">
                        {formData.lang === "fr" ? "Déchargé" : "Discharged"}
                    </ToggleButton>
                </ToggleButtonGroup>
                <div className="error-text">{bankruptcyError}</div>
                <div className="textfield-label">{formData.lang === "fr" ? "Êtes-vous actuellement dans une proposition de consommateur?" : "Are you currently in a consumer proposal?"}</div>

                <ToggleButtonGroup
                    value={formData.inConsumerProposal}
                    exclusive
                    onChange={onConsumerProposalChange}>
                    <ToggleButton value="yes">
                        {formData.lang === "fr" ? "Oui" : "Yes"}
                    </ToggleButton>
                    <ToggleButton value="no">
                        {formData.lang === "fr" ? "Non" : "No"}
                    </ToggleButton>
                    <ToggleButton value="discharged">
                        {formData.lang === "fr" ? "Déchargé" : "Discharged"}
                    </ToggleButton>
                </ToggleButtonGroup>
                <div className="error-text">{consumerProposalError}</div>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                validateData();
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default DebtStatus;